/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Информация о грузе в виде общего веса и объема
 */
export type OrderCopyCargoByTotal = {
  /**
   * Тип посылки
   */
  type: OrderCopyCargoByTotal.type
  /**
   * Максимальная высота грузоместа (в см)
   */
  height: number
  /**
   * Максимальная ширина грузоместа (в см)
   */
  width: number
  /**
   * Максимальная длина грузоместа (в см)
   */
  length: number
  /**
   * Максимальный вес грузоместа (в г)
   */
  maxWeight?: null | number
  /**
   * Общий вес груза (в г)
   */
  weight: number
  /**
   * Общий объем груза (в м3)
   */
  volume: number
  /**
   * Характер груза (о грузе)
   */
  about: string
  /**
   * Оценочная стоимость
   */
  price: number
  /**
   * Общее количество грузомест
   */
  amount: number
}
export namespace OrderCopyCargoByTotal {
  /**
   * Тип посылки
   */
  export enum type {
    CUSTOM = 'custom'
  }
}
